import { useTranslation } from 'react-i18next'

import { BaseView, BaseText } from '@/components/base'
import {
  TransferInAmountWithSwap,
  TransferInAvailableWalletAmount,
  TransferInNumberPad,
  TransferInButtonConfirmation,
  // TransferInHeader,
  ResetTransferInOnRouteEntry,
} from '@/features/savings'
import { useUserStore } from '@/store/useUserStore'
import useOffsets from '@/hooks/useOffsets'
import { StickyHeaderNavigation } from '@/components/StickyHeaderNavigation'

export default function TransferInScreen() {
  const { t } = useTranslation()
  const offsets = useOffsets()

  // Get wallet data
  const completeCurrencies = useUserStore((s) => s.wallet?.completeCurrencies)

  // Show error if no available currencies
  if (!completeCurrencies?.length) {
    return (
      <BaseView
        flex={1}
        center
        bgColor="background.screen"
        style={{
          height: '100vh',
          paddingTop: offsets.top + 70,
        }}
      >
        <BaseText fontSize={16} color="label.secondary" textAlign="center">
          {'No currencies available'}
        </BaseText>
      </BaseView>
    )
  }

  return (
    <>
      <ResetTransferInOnRouteEntry />

      <BaseView
        flex={1}
        bgColor="background.screen"
        style={{
          height: '100vh',
          paddingTop: offsets.top + 70,
        }}
      >
        {/* Header */}
        {/* <TransferInHeader /> */}
        <StickyHeaderNavigation title={t('form:actions.transferIn')} />

        <BaseView flex={1} px={12} className="flex flex-col h-full">
          {/* Central area with amount display */}
          <BaseView
            align="center"
            gap={14}
            className="flex-1 flex flex-col justify-start"
            style={
              {
                // paddingTop: 28,
              }
            }
          >
            <BaseView gap={16} center>
              <TransferInAmountWithSwap />
              <TransferInAvailableWalletAmount />
            </BaseView>
          </BaseView>

          {/* Bottom area with keyboard and button */}
          <BaseView
            className="mt-auto"
            gap={12}
            style={{ paddingBottom: offsets.bottom }}
          >
            <TransferInNumberPad />
            <TransferInButtonConfirmation />
          </BaseView>
        </BaseView>
      </BaseView>
    </>
  )
}
